import {Action, ActionReducerMap} from '@ngrx/store';
import * as actionsUi from './qschecks-controlling-filter.actions.ui';
import {GET_FUNKTIONSBEREICHE_PRUEFPLAENE_CONTROLLING, GET_FUNKTIONSBEREICHE_PRUEFPLAENE_CONTROLLING_ERFOLGREICH, GET_FUNKTIONSBEREICHE_PRUEFPLAENE_CONTROLLING_FEHLER, GET_PRUEFPLAN_FILTER, GET_PRUEFPLAN_FILTER_ERFOLGREICH, GET_PRUEFPLAN_FILTER_FEHLER, GetFunktionsbereichePruefplaeneControllingErfolgreichAction, GetPruefplanFilterErfolgreichAction} from '../../../../client-ngrx/qschecks';
import {FilterOption, FunktionsbereichPruefplaene, Pruefplan} from '../../../../clients/qschecks';
import {AKTUELLE_PRUEFPLAN_ID_SETZEN, AKTUELLEN_PRUEFPLAN_SETZEN, AktuellenPruefplanSetzenAction, AktuellePruefplanIdSetzenAction} from './qschecks-controlling-filter.actions.ui';
export interface ModuleState {
    page: PageState;
}
export const reducers: ActionReducerMap<ModuleState> = {
    page: pageReducer
};
export interface PageState {
    fbPruefplaeneListe: Array<FunktionsbereichPruefplaene>;
    fbPruefplaeneListeLaden: boolean;
    fbPruefplaeneListeFehler: boolean;
    pruefplanSelected: Pruefplan;
    pruefplanSelectedId: string;
    filterOptions: FilterOption;
    filterOptionsLaden: boolean;
    filterOptionsFehler: boolean;
}
export const initialPageState: PageState = {
    fbPruefplaeneListe: [],
    fbPruefplaeneListeLaden: false,
    fbPruefplaeneListeFehler: false,
    pruefplanSelected: null,
    pruefplanSelectedId: null,
    filterOptions: null,
    filterOptionsLaden: false,
    filterOptionsFehler: false
};
export function pageReducer(state = initialPageState, action: Action): PageState {
    switch (action.type) {
        // Page State Reset
        case actionsUi.PAGE_STATE_RESET: {
            return Object.assign({}, state, <PageState>initialPageState);
        }
        /* FB-Prüfpläne */
        case GET_FUNKTIONSBEREICHE_PRUEFPLAENE_CONTROLLING: {
            return Object.assign({}, state, <PageState>{
                fbPruefplaeneListeLaden: true,
                fbPruefplaeneListeFehler: false
            });
        }
        case GET_FUNKTIONSBEREICHE_PRUEFPLAENE_CONTROLLING_ERFOLGREICH: {
            const a = <GetFunktionsbereichePruefplaeneControllingErfolgreichAction>action;
            let pruefplanSelectedId: string = null;
            if (state.pruefplanSelectedId !== null) {
                pruefplanSelectedId = state.pruefplanSelectedId;
            }
            let pruefplanSelected: Pruefplan = null;
            if (state.pruefplanSelected !== null) {
                pruefplanSelected = Object.assign(state.pruefplanSelected);
            }
            if (a.payload !== null && a.payload.length > 0 && pruefplanSelectedId !== null) {
                a.payload.forEach((pruefplan) => {
                    const index = pruefplan.pruefplan_liste.findIndex(x => x.pruefplan_id === pruefplanSelectedId);
                    if (index >= 0) {
                        pruefplanSelected = pruefplan.pruefplan_liste[index];
                        pruefplanSelectedId = pruefplanSelected.pruefplan_id;
                    }
                });
            }
            return Object.assign({}, state, <PageState>{
                fbPruefplaeneListe: a.payload,
                pruefplanSelected,
                pruefplanSelectedId,
                fbPruefplaeneListeLaden: false,
                fbPruefplaeneListeFehler: false,
            });
        }
        case GET_FUNKTIONSBEREICHE_PRUEFPLAENE_CONTROLLING_FEHLER: {
            return Object.assign({}, state, <PageState>{
                fbPruefplaeneListe: [],
                fbPruefplaeneListeLaden: false,
                fbPruefplaeneListeFehler: true,
            });
        }
        /* Filter-Optionen */
        case GET_PRUEFPLAN_FILTER: {
            return Object.assign({}, state, <PageState>{
                filterOptionsLaden: true,
                filterOptionsFehler: false
            });
        }
        case GET_PRUEFPLAN_FILTER_ERFOLGREICH: {
            const a = <GetPruefplanFilterErfolgreichAction>action;
            return Object.assign({}, state, <PageState>{
                filterOptions: a.payload,
                filterOptionsLaden: false,
                filterOptionsFehler: false,
            });
        }
        case GET_PRUEFPLAN_FILTER_FEHLER: {
            return Object.assign({}, state, <PageState>{
                filterOptions: null,
                filterOptionsLaden: false,
                filterOptionsFehler: true,
            });
        }
        case AKTUELLEN_PRUEFPLAN_SETZEN: {
            const a = <AktuellenPruefplanSetzenAction>action;
            return Object.assign({}, state, <PageState>{
                pruefplanSelected: a.payload,
                pruefplanSelectedId: a.payload.pruefplan_id
            });
        }
        case AKTUELLE_PRUEFPLAN_ID_SETZEN: {
            const a = <AktuellePruefplanIdSetzenAction>action;
            let pruefplanSelected: Pruefplan = null;
            if (state.pruefplanSelected !== null) {
                pruefplanSelected = Object.assign({}, state.pruefplanSelected);
            }
            if (state.fbPruefplaeneListe !== null && state.fbPruefplaeneListe.length > 0 && a.payload !== null) {
                state.fbPruefplaeneListe.forEach((pruefplan) => {
                    const index = pruefplan.pruefplan_liste.findIndex(x => x.pruefplan_id === a.payload);
                    if (index >= 0) {
                        pruefplanSelected = pruefplan.pruefplan_liste[index];
                    }
                });
            }
            return Object.assign({}, state, <PageState>{
                pruefplanSelected,
                pruefplanSelectedId: a.payload
            });
        }
        default: {
            return state;
        }
    }
}
